import { render, staticRenderFns } from "./UrgentenEdit.vue?vue&type=template&id=2bb2f19a&scoped=true&"
import script from "./UrgentenEdit.vue?vue&type=script&lang=js&"
export * from "./UrgentenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2f19a",
  null
  
)

export default component.exports